<template>
    <v-card class="fill-height">
        <v-toolbar card dark color="primary">
            <v-toolbar-title>Inloggen</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat icon @click="$emit('close')">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-stepper v-model="step" class="fill-height">
            <v-stepper-header>
                <v-stepper-step :complete="step > 1" step="1">Gebruikersnaam</v-stepper-step>
                <v-divider />
                <v-stepper-step :complete="step > 2" step="2">Authenticatie</v-stepper-step>
                <v-divider />
                <v-stepper-step :complete="step > 3" step="3">Klaar</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content step="1">
                    <v-form ref="form" @submit.prevent="onSubmit">
                        <v-text-field
                            autofocus
                            label="Gebruikersnaam"
                            v-model="formUsername"
                            :disabled="!!username"
                            />
                    </v-form>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <v-alert :value="true" type="info" border="left">
                        <h4>Volg de instructies</h4>
                        <p>
                            Volg nu de instructies op je telefoon, browser of ander apparaat.
                        </p>
                    </v-alert>
                </v-stepper-content>

                <v-stepper-content step="3">
                    <v-alert :value="true" type="success" border="left">
                        <h4>Het is gelukt!</h4>
                        <p>
                            Je bent nu ingelogd als gebruiker <strong>{{ formUsername }}</strong>.
                        </p>
                    </v-alert>
                    <p>
                        Je gaat nu terug naar de overzichtspagina.
                    </p>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>

        <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="onNextClick" v-if="step === 1">
                <v-icon class="mr-2">navigate_next</v-icon>
                Volgende
            </v-btn>
            <v-btn color="success" @click="$emit('close')" v-if="step === 3">
                <v-icon class="mr-2">check</v-icon>
                Sluiten
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import client from './client'

export default {
    props: {
        username: {
            type: String,
            required: false,
            default: '',
        },
    },
    data () {
        return {
            step: 1,
            formUsername: this.username,
            platformAvailable: null,
        }
    },
    methods: {
        async login () {
            try {
                this.step = 2
                await this.$nextTick()
                await client.login(this.formUsername)
                this.step = 3
            } catch (e) {
                this.handleError(e)
                this.step = 1
            }
        },
        onNextClick () {
            this.step++
            if (this.step === 2) {
                this.login()
            }
        },
        handleError (e) {
            if (e.name === 'NotAllowedError') {
                window.alert('Authenticatie is niet gelukt. Heb je de popup waarin werd gevraagd om je te identificeren gesloten? Deze fout komt ook voor als je te lang hebt gewacht.')
                return
            }

            if (e.name === 'InvalidStateError') {
                window.alert('Inloggen is niet gelukt. Je hebt waarschijnlijk een verkeerde sleutel gebruikt.')
                return
            }

            if (e.name === 'UserAuthError') {
                window.alert(e.message)
                return
            }

            window.alert('Onbekende fout: (' + e.name + ') ' + e.message)
        },
    },
}
</script>
